import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=35bc4306"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bc4306')) {
      api.createRecord('35bc4306', component.options)
    } else {
      api.reload('35bc4306', component.options)
    }
    module.hot.accept("./NavBar.vue?vue&type=template&id=35bc4306", function () {
      api.rerender('35bc4306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stores/Editor/Navigation/NavBar.vue"
export default component.exports